import Vue from "vue";

import { mandatePresenceStatuses } from "@/constants/mandate.js";

export default {
  state: {
    mandatesLastSeen: {},
  },
  mutations: {
    deleteMandateLastSeen(state, payload) {
      const mandatesLastSeen = Object.assign({}, state.mandatesLastSeen);
      delete mandatesLastSeen[payload.id];
      state.mandatesLastSeen = mandatesLastSeen;
      // delete state.mandatesLastSeen[payload.id];
    },
    upsertMandateLastSeen(state, payload) {
      Vue.set(state.mandatesLastSeen, payload.id, {
        id: payload.id,
        last_seen: payload.last_seen,
      });
    },
  },
  getters: {
    getMandateLastSeen: state => mandateLastSeenId => {
      return state.mandatesLastSeen[mandateLastSeenId];
    },

    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    checkIfRepresentsOtherMandates: state => mandate => {
      return !!Object.values(state.data).find(item => {
        if (mandate.representant_owner_id) {
          return (
            item.representant_owner_id == mandate.representant_owner_id &&
            item.building_owner_id !== mandate.building_owner_id
          );
        } else if (mandate.representant_contact_id) {
          return (
            item.representant_contact_id == mandate.representant_contact_id &&
            item.building_owner_id !== mandate.building_owner_id
          );
        }
        return false;
      });
    },
    getMandatesByMeeting: state => meetingId => {
      return Object.values(state.data).filter(item => {
        return item.meeting_id == meetingId;
      });
    },
    getMandatesThatArePresentInSomeWay: state => () => {
      return Object.values(state.data).filter(item => {
        return (
          item.presence_status != null &&
          item.presence_status != mandatePresenceStatuses.not_present &&
          item.presence_status != mandatePresenceStatuses.invalid &&
          item.presence_status != mandatePresenceStatuses.pouvoir_by_video_not_present_yet
        );
      });
    },
    getMandatesForMeetingPresence: (state, getters, rootState, rootGetters) => meetingId => {
      var mandates = getters.getMandatesByMeeting(meetingId);
      return mandates.map(mandate => {
        return {
          ...mandate,
          resolution_votes: rootGetters["entities/resolution_vote/getResolutionVotesByMandate"](
            mandate.id
          ),
        };
      });
    },
    getMandatesForMeetingStart: (state, getters, rootState, rootGetters) => meetingId => {
      return getters.getMandatesByMeeting(meetingId);
    },
    getRepresentedMandate: state => mandate => {
      return Object.values(state.data).find(item => {
        if (mandate.representant_owner_id) {
          if (
            item.id != mandate.id &&
            item.representant_owner_id == mandate.representant_owner_id &&
            item.building_owner_id == item.representant_owner_id
          ) {
            return item;
          }
        }
      });
    },
  },
};
